import { TOGGLE_FULL_SCREEN } from "../actions/fullscreenBlock";
import { changeInAllObjects, updateObjectById } from '../utilites/newReducerHelpers';
var initialState = {};
var initialScreenData = {
    isFullScreen: false
};
var toggleStateFullScreen = function (state, action) {
    var _a;
    var isFullScreen = Boolean((_a = state === null || state === void 0 ? void 0 : state[action.payload]) === null || _a === void 0 ? void 0 : _a.isFullScreen);
    var newState = changeInAllObjects(state, { isFullScreen: false });
    return updateObjectById(newState, action.payload, { isFullScreen: !isFullScreen }, initialScreenData);
};
export function fullScreenReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case TOGGLE_FULL_SCREEN:
            return toggleStateFullScreen(state, action);
        default:
            return state;
    }
}
export function getCurrentFullscreen(state, postId) {
    var _a;
    return ((_a = state.fullScreen[postId]) === null || _a === void 0 ? void 0 : _a.isFullScreen) || false;
}
export function getCurrentAnyFullscreen(state) {
    return Object.values(state.fullScreen).some(function (el) { return el === null || el === void 0 ? void 0 : el.isFullScreen; });
}
//# sourceMappingURL=fullScreenReducer.js.mapimport { TOGGLE_FULL_SCREEN } from "../actions/fullscreenBlock";
import { changeInAllObjects, updateObjectById } from '../utilites/newReducerHelpers';
var initialState = {};
var initialScreenData = {
    isFullScreen: false
};
var toggleStateFullScreen = function (state, action) {
    var _a;
    var isFullScreen = Boolean((_a = state === null || state === void 0 ? void 0 : state[action.payload]) === null || _a === void 0 ? void 0 : _a.isFullScreen);
    var newState = changeInAllObjects(state, { isFullScreen: false });
    return updateObjectById(newState, action.payload, { isFullScreen: !isFullScreen }, initialScreenData);
};
export function fullScreenReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case TOGGLE_FULL_SCREEN:
            return toggleStateFullScreen(state, action);
        default:
            return state;
    }
}
export function getCurrentFullscreen(state, postId) {
    var _a;
    return ((_a = state.fullScreen[postId]) === null || _a === void 0 ? void 0 : _a.isFullScreen) || false;
}
export function getCurrentAnyFullscreen(state) {
    return Object.values(state.fullScreen).some(function (el) { return el === null || el === void 0 ? void 0 : el.isFullScreen; });
}
//# sourceMappingURL=fullScreenReducer.js.map